import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ToastsService } from './toasts.service';
import { ToastComponent } from './toast/toast.component';
import { CommonModule } from '@angular/common';
declare var $: any;

@Component({
  selector: 'shared-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.css'],
  imports: [
    CommonModule,
    ToastComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastsComponent implements OnInit {    

    constructor(
        public toastsService: ToastsService
    ) { }

    ngOnInit() {   
    }

    onToastHidden(id: string) {
        let idx = this.toastsService.toasts.findIndex(x => x.id == id);
        if (idx != -1) {
            this.toastsService.toasts.splice(idx, 1);
        }
    }
}
